import {useParams} from "react-router-dom";
import {
    useCreateDepartmentMutation,
    useGetDepartmentQuery,
    useUpdateDepartmentMutation
} from "../../apis/departmentApi";
import {useListCompanyAccountsQuery} from "../../apis/companiesApi";
import FormModal from "../../components/modals/FormModal";
import {InputText} from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import {Dropdown} from "primereact/dropdown";
import {React} from "react";
import SingleValueDynamicTable from "../../components/tables/SingleValueDynamicTable";
import TwoColumnMetricTable from "../../components/tables/TwoColumnMetricTable";
import _ from "lodash";
import {useUserProfileQuery} from "../../apis/authenticationApi";
import { useListPossibleParentDepartments } from "hooks/departmentHooks";

const OrganizationalIndexModal = () => {
    const {department, parent} = useParams();
    const [createDepartment] = useCreateDepartmentMutation();
    const [updateDepartment] = useUpdateDepartmentMutation();
    const {data: editDepartment, isFetching} = useGetDepartmentQuery(department);
    const {data: companyUsers, isFetching: isFetchingCompanyUsers} = useListCompanyAccountsQuery();
    const {data: userProfile} = useUserProfileQuery();
    const {departments: parentDepartments, isFecthing: isFetchingParentDepartments} = useListPossibleParentDepartments(department);
    const viewOnly = !['CompanyOwner'].includes(userProfile?.company?.role);

    const handleSubmit = (data) => {
        const clonedData = _.cloneDeep(data);

        clonedData.responsibilities = (clonedData.responsibilities || []).map(entry => entry?.value);
        clonedData.attributes = (clonedData.attributes || []).map(entry => entry?.value);
        clonedData.parent = parent || clonedData.parent;

        if(!data.id || data.id === 'new') {
            createDepartment(clonedData);
        }
        else {
            updateDepartment(clonedData)
        }
    }

    const responsibleItemTemplate = (option) => {
        return option?.registered ? `${option?.firstName} ${option?.lastName}` : option?.email;
    }

    const responsibleValueTemplate = (option) => {
        const user = companyUsers.find(user => user.id === option?.id);
        return user ? (user?.registered ? `${user?.firstName} ${user?.lastName}` : user?.email) : "Select Department Head";
    }

    const responsibleDepartmentTemplate = (option) => {
        return (option?.name || option?.title) ?? "";
    }

    if(isFetching || isFetchingCompanyUsers) {
        return (<></>);
    }

    const clonedDepartment = _.cloneDeep(editDepartment || {name: ''});

    clonedDepartment.responsibilities = (clonedDepartment.responsibilities || []).map(entry => {return {value: entry}});
    clonedDepartment.attributes = (clonedDepartment.attributes || []).map(entry => {return {value: entry}});

    return (<FormModal type="Role" editObject={clonedDepartment || {name: ''}} handleSubmit={handleSubmit} disabled={viewOnly}
           renderForm={(formik) =>
               (<form onSubmit={formik.handleSubmit} className="formgrid grid">
                   <div className="col-12">
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="name" name="name" className="inputfield w-full" value={formik.values?.name} onChange={formik.handleChange} autoFocus disabled={viewOnly}/>
                                <label htmlFor="name">Department</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="title" name="title" className="inputfield w-full" value={formik.values?.title} onChange={formik.handleChange} autoFocus disabled={viewOnly}/>
                                <label htmlFor="title">Title</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <Dropdown name="parent" id="parent" className="w-4" value={formik.values?.parent === '' ? undefined : formik.values?.parent} options={parentDepartments} optionLabel="name" itemTemplate={responsibleDepartmentTemplate} optionValue="id"
                                          onChange={formik.handleChange} disabled={viewOnly || isFetchingParentDepartments} />
                                <label htmlFor="parent">Responsible Department (Parent)</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <Dropdown name="departmentHead" id="departmentHead" className="w-4" value={formik.values?.departmentHead === '' ? undefined : formik.values?.departmentHead} options={companyUsers} optionLabel="id" valueTemplate={responsibleValueTemplate} itemTemplate={responsibleItemTemplate} optionValue="id"
                                          onChange={formik.handleChange} disabled={viewOnly} />
                                <label htmlFor="departmentHead">Responsible Person (Department Head)</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="purpose" name="purpose" className="inputfield w-full" value={formik.values?.purpose} onChange={formik.handleChange} autoFocus disabled={viewOnly}/>
                                <label htmlFor="purpose">Purpose</label>
                            </span>
                       </div>
                       <div className="col-12 flex gap-2 py-4">
                               <span className="font-semibold col-2 read-only-label">Active:</span>
                               <Checkbox id="enabled" name="enabled" onChange={formik.handleChange}  checked={formik.values?.enabled} disabled={viewOnly}/>
                        </div>
                   </div>
                   <div className="col-6">
                       <SingleValueDynamicTable
                           title="Primary Responsibilities"
                           name="responsibilities"
                           formik={formik}
                           disabled={viewOnly}
                       />
                   </div>
                   <div className="col-6">
                       <SingleValueDynamicTable
                           title="Key Attributes"
                           name="attributes"
                           formik={formik}
                           disabled={viewOnly}
                       />
                   </div>
                   <div className="col-12">
                       <TwoColumnMetricTable formik={formik} name="metrics" title="Key Metrics" disabled={viewOnly} />
                   </div>
               </form>)
           }>
    </FormModal>)
}

export default OrganizationalIndexModal;
